const navStyles = {
	control: (baseStyles, state) => ({
		...baseStyles,
		border: 0,
		boxShadow: 'none',
		backgroundColor: state.isFocused ? 'var(--color-grey-100)' : 'transparent',
		color: 'var(--color-text)',
		fontSize: 'var(--textsize-xs)',
		minHeight: '1em',
		// Matches the focus ring in global-styles/buttons.scss.
		outline: state.isFocused ? '1.5px solid var(--color-link)' : 'none',
		outlineOffset: '2.5px',
		transition:
			'color var(--nav-color-transition-duration) ease-in-out, background-color var(--nav-color-transition-duration) ease-in-out',
		transitionDelay: 'var(--nav-color-transition-delay)',
		':hover': {
			backgroundColor: 'var(--color-grey-100)',
		},
	}),
	singleValue: (baseStyles) => ({
		...baseStyles,
		color: 'var(--color-text)',
		transition: 'color var(--nav-color-transition-duration) ease-in-out',
		transitionDelay: 'var(--nav-color-transition-delay)',
	}),
	input: (baseStyles, state) => ({
		...baseStyles,
		backgroundColor: state.isFocused ? 'var(--color-grey-100)' : 'transparent',
	}),
	dropdownIndicator: (baseStyles) => ({
		...baseStyles,
		display: 'none',
	}),
	valueContainer: (baseStyles) => ({
		...baseStyles,
		padding: '2px 8px',
	}),
	option: (baseStyles, state) => ({
		...baseStyles,
		backgroundColor: state.isFocused
			? 'var(--color-grey-100)'
			: 'var(--color-white)',
		color: '#000',
		padding: '0',
		marginTop: '0',
	}),
	menu: (baseStyles) => ({
		...baseStyles,
		borderRadius: '4px',
		border: '0',
		boxShadow: '0 1px 6px 2px rgba(0, 0, 0, 0.25)',
		height: 'auto',
		margin: '4px 0 0',
		minWidth: 'min(150px, 90vw)',
		overflow: 'hidden',
		zIndex: '1000', // otherwise the hit targets are often covered
	}),
};

export default navStyles;
